import { PasswordInput as $PasswordInput } from '@mantine/core';
import type { PasswordInputProps as $PasswordInputProps } from '@mantine/core';
import { useController } from 'react-hook-form';
import type { FieldValues, UseControllerProps } from 'react-hook-form';

type PasswordInputProps<T extends FieldValues> = UseControllerProps<T> &
  Omit<$PasswordInputProps, 'value' | 'defaultValue'>;

export function PasswordInput<T extends FieldValues>({
  name,
  control,
  defaultValue,
  rules,
  shouldUnregister,
  onChange,
  ...props
}: PasswordInputProps<T>) {
  const {
    field: { value, onChange: fieldOnChange, ref: _fieldRef, ...field },
    fieldState,
  } = useController<T>({
    name,
    control,
    defaultValue,
    rules,
    shouldUnregister,
  });

  return (
    <$PasswordInput
      error={fieldState.error?.message}
      value={value}
      onChange={(e) => {
        fieldOnChange(e);
        onChange?.(e);
      }}
      {...field}
      {...props}
    />
  );
}
